import { render } from "./modalCompany.vue?vue&type=template&id=31ecb00b&scoped=true"
import script from "./modalCompany.vue?vue&type=script&lang=js"
export * from "./modalCompany.vue?vue&type=script&lang=js"

import "./modalCompany.vue?vue&type=style&index=0&id=31ecb00b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ecb00b"]])

export default __exports__